import { render, staticRenderFns } from "./FavoritesLink.vue?vue&type=template&id=27c6cfab"
import script from "./FavoritesLink.vue?vue&type=script&lang=js"
export * from "./FavoritesLink.vue?vue&type=script&lang=js"
import style0 from "./FavoritesLink.vue?vue&type=style&index=0&id=27c6cfab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports